import 'magnific-popup';

/**
 * Popup Handler Module
 * Handles popup initialization and popup sliders
 */

const handlePopups = () => {
    $('.js-open-popup').magnificPopup({
        type: 'inline',
    });

    $('.js-open-popup').on('click', function(event) {
        const target = $(this).attr('href');

        if (!$(target).find('.js-slider-popup').length) {
            return;
        }

        const $slider = $(target).find('.js-slider-popup .slider__slides');
        const $prevArrow = $(target).find('.js-slider-arrow-prev');
        const $nextArrow = $(target).find('.js-slider-arrow-next');

        $slider.not('.slick-initialized').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            useTransform: false,
            prevArrow: $prevArrow,
            nextArrow: $nextArrow,
        });

        setTimeout(() => {
            $slider.find('.slick-dots .slick-active button').focus();
        }, 300);
    });
};

export default handlePopups;

